import axios from 'axios'
import getString from '../config/strings'
import { get } from './axiosService'
import { DATA_HOST, REST_DATA_URL, REST_FILE_URL } from '../config/config'

class APIService {

  static getCard (token) {
    const baseurl = DATA_HOST + REST_DATA_URL
    return get(baseurl, {}, token, getString('ERROR_HTTP_COMMUNICATION'))
  }

  static setCard (record, token) {
    const baseurl = DATA_HOST + REST_DATA_URL

    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      timeout: 15000
    }

    return new Promise(function (resolve, reject) {
      if (record.id) {
        axios.put(baseurl + '/' + record.id, record, config).then(function (result) {
          if (result.status === 200 || result.status === 201) {
            resolve(result.data)
          } else {
            reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
          }
        }).catch(function (error) {
          if (error && error.response && error.response.data && error.response.data.errors) {
            reject(new Error(error.response.data.errors.join(',')))
          } else {
            reject(error)
          }
        })
      } else {
        axios.post(baseurl, record, config).then(function (result) {
          if (result.status === 201 || result.status === 201) {
            resolve(result.data)
          } else {
            reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
          }
        }).catch(function (error) {
          if (error && error.response && error.response.data && error.response.data.errors) {
            reject(new Error(error.response.data.errors.join(',')))
          } else {
            reject(error)
          }
        })
      }
    })
  }

  static uploadFile (uploadForm, token) {
    const baseurl = DATA_HOST + REST_FILE_URL

    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      timeout: 300000
    }

    let formData = new FormData(uploadForm)
    return new Promise(function (resolve, reject) {
      axios.post(baseurl, formData, config).then(function (result) {
        console.log('upload file success ', result)
        if (result.status === 200 || result.status === 201) {
          resolve(result.data)
        } else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (error) {
        if (error && error.response && error.response.data && error.response.data.errors) {
          reject(new Error(error.response.data.errors.join(',')))
        } else {
          reject(error)
        }
      })
    })
  }
}

export default APIService